<div
  class="customer-page"
  *ngIf="
    sectionList.length > 0 && summaryList.length > 0 && documentList.length > 0
  "
>
  <div class="grid-container">
    <div class="grid-1">
      <div class="top-grid">
        <div class="application-container">
          <div class="application-header">
            <div class="title-wrapper">
              <mat-icon fontSet="material-icons-outlined"
                >assignment_outlined</mat-icon
              >
              <div>
                {{ "kopetro.reviewApplication.applicationDetail" | translate }}
              </div>
            </div>

            <div class="subtitle-wrapper">
              <div>
                {{
                  "kopetro.reviewApplication.applicationDateTime" | translate
                }}
              </div>
              <span>{{
                data.createdDate | date : "dd MMM yyyy hh:mm aa"
              }}</span>
            </div>
          </div>

          <div class="print-wrapper" (click)="onPrint()">
            <mat-icon fontSet="material-icons-outlined">print</mat-icon>
            <div>
              {{ "kopetro.reviewApplication.printApplication" | translate }}
            </div>
          </div>
        </div>

        <mat-tab-group [(selectedIndex)]="activeTabIndex">
          <mat-tab *ngFor="let section of sectionList">
            <ng-template mat-tab-label>
              <span>{{ section.section | translate }}</span>
            </ng-template>

            <div class="section-container">
              <ng-container
                *ngIf="section.sectionList?.length > 0; else termsAndSignature"
              >
                <div
                  class="section-wrapper"
                  *ngFor="let sub of section.sectionList"
                >
                  <div class="section-header">
                    <mat-icon fontSet="material-icons-outlined">{{
                      sub.sectionIcon
                    }}</mat-icon>
                    <div>{{ sub.sectionTitle | translate }}</div>
                  </div>

                  <mat-divider></mat-divider>

                  <div class="field-wrapper">
                    <div class="field-item" *ngFor="let field of sub.fieldList">
                      <div class="label">
                        {{ field.codeDesc | translate }}
                      </div>
                      <div class="value">{{ field.codeValue }}</div>
                    </div>
                  </div>
                </div>
              </ng-container>

              <ng-template #termsAndSignature>
                <div class="section-wrapper">
                  <div
                    class="terms-title"
                    [innerHTML]="'kopetro.customerForm.termsTitle' | translate"
                  ></div>
                  <div
                    [innerHTML]="'kopetro.customerForm.termsTitle2' | translate"
                  ></div>

                  <ol>
                    <li *ngFor="let num of terms" [value]="num">
                      {{ "kopetro.customerForm.terms" + num | translate }}
                    </li>
                  </ol>
                </div>

                <div class="signature-container">
                  <div class="signature-wrapper">
                    <div class="signature">
                      <div>
                        {{ "kopetro.customerForm.signature" | translate }}
                      </div>
                      <div>{{ data.signature }}</div>
                    </div>

                    <div class="date">
                      <div>
                        {{ "kopetro.customerForm.date" | translate }}
                      </div>
                      <div>{{ data.signedDate | date : "dd/MM/yyyy" }}</div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>

      <div class="bottom-grid">
        <div class="title-wrapper">
          <mat-icon fontSet="material-icons-outlined"
            >assignment_outlined</mat-icon
          >
          <div>
            {{ "kopetro.reviewApplication.submittedDoc" | translate }}
          </div>
        </div>

        <div class="document-wrapper">
          <div class="document-item" *ngFor="let doc of documentList">
            <div class="section-header">
              <mat-icon fontSet="material-icons-outlined"
                >insert_drive_file</mat-icon
              >
              <div>{{ doc.fileName }}</div>
            </div>

            <button
              mat-stroked-button
              class="download"
              (click)="onDownload(doc)"
            >
              {{ "common.download" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="grid-2">
      <div class="summary-container">
        <div class="section-header">
          <mat-icon fontSet="material-icons-outlined"
            >assignment_outlined</mat-icon
          >
          <div>
            {{ "kopetro.reviewApplication.applicationSummary" | translate }}
          </div>
        </div>

        <mat-divider></mat-divider>

        <div class="field-wrapper">
          <div class="field-item" *ngFor="let summary of summaryList">
            <div class="label">{{ summary.codeDesc | translate }}</div>
            <div class="value">{{ summary.codeValue }}</div>
          </div>
        </div>
      </div>

      <div class="attention-container">
        <div class="title">
          {{ "kopetro.reviewApplication.attention" | translate }}
        </div>
        <div class="desc">
          {{ "kopetro.reviewApplication.attentionDetail" | translate }}
        </div>
      </div>

      <div class="button-wrapper" *ngIf="data.status === 'Processing'">
        <button
          mat-flat-button
          class="approve"
          [disabled]="activeTabIndex !== 2"
          (click)="onApprove()"
        >
          {{ "kopetro.reviewApplication.approve" | translate }}
        </button>
        <button
          mat-flat-button
          class="reject"
          [disabled]="activeTabIndex !== 2"
          (click)="onReject()"
        >
          {{ "kopetro.reviewApplication.reject" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
